"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = exports.OfferType = exports.UnavailableReason = exports.ILineItemCustomFields = void 0;
var debug_1 = __importDefault(require("debug"));
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var pick_1 = __importDefault(require("lodash/pick"));
var _1 = require(".");
var buildUpdateActions_1 = require("./lib/buildUpdateActions");
var helpers_1 = require("./utils/helpers");
var money_1 = __importDefault(require("./utils/money"));
var sku_1 = require("./utils/sku");
var debug = (0, debug_1.default)('nuts:ad');
var ILineItemBaseFields = {
    names: ['quantity', 'sku', 'addedAt'],
};
exports.ILineItemCustomFields = {
    names: [
        'active',
        'cancellationReason',
        'cancellationReasonDetails',
        'cancelledAt',
        'committedPiecePrice',
        'createdByOrderSkuId',
        'expiresOn',
        'interval',
        'lastEventEmitted',
        'lastEventEmittedAt',
        'lastOrderPiecePrice',
        'lastOrderPlacedAt',
        'nextNextShipOn',
        'nextShipOn',
        'nextShipOnAtCancellation',
        'offerLocation',
        'offerType',
        'ogSubscriptionId',
        'ogUserId',
        'shippingAddressId',
    ],
};
var UnavailableReason;
(function (UnavailableReason) {
    UnavailableReason["ProductNotPublished"] = "ProductNotPublished";
    UnavailableReason["VariantBackordered"] = "VariantBackordered";
    UnavailableReason["VariantHasNoPrice"] = "VariantHasNoPrice";
    UnavailableReason["VariantInactive"] = "VariantInactive";
    UnavailableReason["VariantIneligible"] = "VariantIneligible";
})(UnavailableReason = exports.UnavailableReason || (exports.UnavailableReason = {}));
var OfferType;
(function (OfferType) {
    OfferType["IURecurring"] = "IU Recurring";
    OfferType["IUUpsell"] = "IU Upsell";
    OfferType["OneClickIURecurring"] = "One Click-IU Recurring";
    OfferType["Standard"] = "Standard";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var Subscription = /** @class */ (function () {
    function Subscription(client, lineItem, shippingAddress, productInfo) {
        var _a, _b, _c, _d;
        this.client = client;
        this.lineItem = lineItem;
        if (!lineItem.custom || !lineItem.variant || !lineItem.variant.sku) {
            throw new Error('invalid line item');
        }
        this.id = lineItem.id;
        this.name = lineItem.name;
        this.quantity = lineItem.quantity;
        this.addedAt = lineItem.addedAt;
        this.deactivatedAt = lineItem.deactivatedAt;
        this.variant = __assign(__assign({}, lineItem.variant), (0, helpers_1.pivotAttributeValues)(lineItem.variant.attributes).variant);
        this.images = (_a = productInfo === null || productInfo === void 0 ? void 0 : productInfo.images) !== null && _a !== void 0 ? _a : lineItem.variant.images;
        this.productPath = productInfo === null || productInfo === void 0 ? void 0 : productInfo.productPath;
        this.shippingAddress = shippingAddress;
        this.sku = lineItem.variant.sku;
        this.variantName = this.variant.variantName;
        if (!this.variant.autoDeliveryEligible) {
            this.unavailableReason = UnavailableReason.VariantIneligible;
        }
        else if (!this.variant.active) {
            this.unavailableReason = UnavailableReason.VariantInactive;
        }
        else if (this.variant.backordered) {
            this.unavailableReason = UnavailableReason.VariantBackordered;
        }
        else if (lineItem.deactivatedAt) {
            this.unavailableReason = UnavailableReason.ProductNotPublished;
        }
        Object.assign(this, lineItem.custom.fields);
        var price = (_c = (_b = this.variant.prices) === null || _b === void 0 ? void 0 : _b.find(function (p) { return p.value.currencyCode === 'USD'; })) === null || _c === void 0 ? void 0 : _c.value;
        if (!price) {
            this.unavailableReason = UnavailableReason.VariantHasNoPrice;
        }
        this.currentPiecePrice = money_1.default.from((0, sku_1.priceForQuantity)(__assign(__assign({}, this.variant), { prices: this.variant.prices, salePrice: money_1.default.dollars(price) }), this.quantity));
        this.piecePrice = (_d = this.committedPiecePrice) !== null && _d !== void 0 ? _d : this.currentPiecePrice;
        this.discountedPiecePrice =
            this.variant.wholesale || !this.interval
                ? this.piecePrice
                : money_1.default.multiply(this.piecePrice, 0.95);
        this.extendedPrice = money_1.default.multiply(this.piecePrice, this.quantity);
        this.extendedPiecePrice = this.extendedPrice;
        this.discountedExtendedPrice = money_1.default.multiply(this.discountedPiecePrice, this.quantity);
        if (this.lastOrderPiecePrice) {
            // if it's within a few cents, consider it the same
            var diff = Math.abs(this.lastOrderPiecePrice.centAmount - this.piecePrice.centAmount);
            if (diff < 3) {
                this.lastOrderPiecePrice = undefined;
            }
        }
    }
    Subscription.calculateNextShipOn = function (_a) {
        var _b, _c;
        var addedAt = _a.addedAt, interval = _a.interval, lastOrderPlacedAt = _a.lastOrderPlacedAt, nextShipOn = _a.nextShipOn;
        if (!interval) {
            return undefined;
        }
        var fixTimestampIfDefined = function (dateTimeString) { var _a; return (_a = dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.replace(/(\+\d\d)(\d\d)$/, '$1:$2')) !== null && _a !== void 0 ? _a : undefined; };
        var lastOn = Date.parse((_c = (_b = nextShipOn !== null && nextShipOn !== void 0 ? nextShipOn : fixTimestampIfDefined(lastOrderPlacedAt)) !== null && _b !== void 0 ? _b : fixTimestampIfDefined(addedAt)) !== null && _c !== void 0 ? _c : new Date().toISOString().substring(0, '0000-00-00'.length));
        var next = lastOn;
        while (next <= lastOn) {
            next += interval * 24 * 60 * 60 * 1000;
        }
        return new Date(next).toISOString().substring(0, '0000-00-00'.length);
    };
    Subscription.create = function (draft, client, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.retryConcurrentModification, retryConcurrentModification = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_d) {
                return [2 /*return*/, (0, _1.retry)(function () { return __awaiter(_this, void 0, void 0, function () {
                        var nextShipOn;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            nextShipOn = (_a = draft.nextShipOn) !== null && _a !== void 0 ? _a : Subscription.calculateNextShipOn(draft);
                            return [2 /*return*/, Subscription.createRaw(__assign(__assign({}, draft), { active: (_b = draft.active) !== null && _b !== void 0 ? _b : true, committedPiecePrice: money_1.default.from(draft.committedPiecePrice), lastOrderPiecePrice: money_1.default.from(draft.lastOrderPiecePrice), nextShipOn: nextShipOn, nextNextShipOn: Subscription.calculateNextShipOn({
                                        interval: draft.interval,
                                        nextShipOn: nextShipOn,
                                    }), shippingAddressId: String(draft.shippingAddressId) }), client)];
                        });
                    }); }, {
                        onError: function (e) { return e.statusCode === 409 && retryConcurrentModification; },
                        reset: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, client.getSubscriptions({
                                            force: true,
                                            preloadImagesAndPaths: false,
                                            preloadPaymentMethod: false,
                                            preloadShippingAddresses: false,
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    })];
            });
        });
    };
    Subscription.createRaw = function (draft, client) {
        return __awaiter(this, void 0, void 0, function () {
            var addedAt, quantity, sku, fields;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addedAt = draft.addedAt, quantity = draft.quantity, sku = draft.sku, fields = __rest(draft, ["addedAt", "quantity", "sku"]);
                        return [4 /*yield*/, client.addLineItem({
                                addedAt: addedAt,
                                quantity: quantity,
                                sku: sku,
                                custom: { type: { typeId: 'type', key: 'autoDeliveryLineItem' }, fields: fields },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscription.validate = function (subscription, setOrNot, errorPrefix) {
        var messages = (0, flatMap_1.default)(setOrNot, function (expected, field) {
            if (expected !== (subscription[field] !== undefined)) {
                return ["".concat(field, " must ").concat(expected ? '' : 'not ', "be set")];
            }
            return [];
        });
        if (messages.length) {
            throw new Error("".concat(errorPrefix).concat(messages.join(', ')));
        }
    };
    Subscription.prototype.product = function (queryArgs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.api
                            .products()
                            .withId({ ID: this.lineItem.productId })
                            .get({ queryArgs: queryArgs })
                            .execute()];
                    case 1: return [2 /*return*/, (_a.sent()).body];
                }
            });
        });
    };
    /** @deprecated since 0.3.8; use .shippingAddress property */
    Subscription.prototype.getShippingAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shippingAddress];
            });
        });
    };
    Subscription.prototype.cancel = function (cancellationReason, cancellationReasonDetails) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update(this.buildCancelFieldChanges(cancellationReason, cancellationReasonDetails), { retryConcurrentModification: true })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscription.prototype.getAlternateVariants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.getAlternateVariants(this.variant)];
            });
        });
    };
    Subscription.prototype.normalize = function (draft) {
        var committedPiecePrice = draft.committedPiecePrice, lastOrderPiecePrice = draft.lastOrderPiecePrice, shippingAddressId = draft.shippingAddressId, other = __rest(draft, ["committedPiecePrice", "lastOrderPiecePrice", "shippingAddressId"]);
        var norm = other;
        if ('committedPiecePrice' in draft) {
            norm.committedPiecePrice = money_1.default.from(committedPiecePrice);
        }
        if ('lastOrderPiecePrice' in draft) {
            norm.lastOrderPiecePrice = money_1.default.from(lastOrderPiecePrice);
        }
        if (shippingAddressId) {
            norm.shippingAddressId = String(shippingAddressId);
        }
        return norm;
    };
    Subscription.prototype.validateChanges = function (changes) {
        var after = __assign(__assign({}, this), changes);
        if (after.active) {
            var orNot = {
                cancelledAt: false,
                cancellationReason: false,
                nextShipOn: true,
            };
            if (after.interval) {
                orNot.nextNextShipOn = true;
            }
            Subscription.validate(after, orNot, 'when subscription is active, ');
        }
        else {
            Subscription.validate(after, {
                cancelledAt: true,
                nextShipOn: false,
                nextNextShipOn: false,
            }, 'when subscription is inactive, ');
        }
    };
    Subscription.prototype.update = function (changes, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.retryConcurrentModification, retryConcurrentModification = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var normalizedChanges, addLineItemActions, latestList, currentListIsFull, newLineItemFields, cancelFieldChanges, subscription;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        normalizedChanges = this.normalize(changes);
                        addLineItemActions = [];
                        if (!(changes.sku && changes.sku !== this.sku)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.client.getLatestShoppingList()];
                    case 1:
                        latestList = _d.sent();
                        return [4 /*yield*/, this.client.checkIfShoppingListIsFull(latestList)];
                    case 2:
                        currentListIsFull = _d.sent();
                        newLineItemFields = this.buildNewLineItemFields(normalizedChanges);
                        if (!currentListIsFull) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.client.createAndSetLists(newLineItemFields)];
                    case 3:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        addLineItemActions.push(__assign(__assign({}, newLineItemFields), { action: 'addLineItem' }));
                        _d.label = 5;
                    case 5:
                        cancelFieldChanges = this.buildCancelFieldChanges({
                            en: "Changing sku to ".concat(changes.sku),
                        });
                        // update normalizedChanges to include canceled fields
                        normalizedChanges = this.normalize(cancelFieldChanges);
                        _d.label = 6;
                    case 6:
                        subscription = this;
                        return [2 /*return*/, (0, _1.retry)(function () { return __awaiter(_this, void 0, void 0, function () {
                                var updateActions, lineItemUpdateActionsByList, listUpdates, _a, _b;
                                var _this = this;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            subscription.validateChanges(normalizedChanges);
                                            updateActions = (0, buildUpdateActions_1.buildUpdateActions)(normalizedChanges, subscription);
                                            return [4 /*yield*/, this.client.buildLineItemUpdateActionsByList(updateActions)];
                                        case 1:
                                            lineItemUpdateActionsByList = _c.sent();
                                            if (!lineItemUpdateActionsByList) {
                                                debug('No line item update actions', {
                                                    lineItemUpdateActionsByList: lineItemUpdateActionsByList,
                                                });
                                                return [2 /*return*/];
                                            }
                                            listUpdates = lineItemUpdateActionsByList.map(function (updateAction, index) {
                                                var list = updateAction.list, _a = updateAction.actions, actions = _a === void 0 ? [] : _a;
                                                var allActions = __spreadArray([], actions, true);
                                                if (index === 0) {
                                                    // only add line item to first list (latest list)
                                                    allActions.push.apply(allActions, addLineItemActions);
                                                }
                                                return _this.client.updateList(list, allActions);
                                            });
                                            _b = (_a = this.client).setLists;
                                            return [4 /*yield*/, Promise.all(listUpdates)];
                                        case 2:
                                            _b.apply(_a, [_c.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, {
                                onError: function (e) {
                                    return (e.statusCode === 409 && retryConcurrentModification) ||
                                        [502, 503].includes(e.statusCode);
                                },
                                reset: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var subscriptions, updatedSubscription;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.client.getSubscriptions({
                                                    force: true,
                                                    includeInactive: true,
                                                    preloadImagesAndPaths: false,
                                                    preloadPaymentMethod: false,
                                                    preloadShippingAddresses: false,
                                                })];
                                            case 1:
                                                subscriptions = _a.sent();
                                                updatedSubscription = subscriptions.find(function (s) { return s.id === subscription.id; });
                                                if (!updatedSubscription) {
                                                    throw new Error("Couldn't find targeted subscription: ".concat(subscription.id));
                                                }
                                                subscription = updatedSubscription;
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                            })];
                }
            });
        });
    };
    Subscription.prototype.resume = function (_a) {
        var _b = _a === void 0 ? {} : _a, nextShipOn = _b.nextShipOn;
        var nextShipOnCalculated = nextShipOn !== null && nextShipOn !== void 0 ? nextShipOn : Subscription.calculateNextShipOn({ interval: this.interval });
        var nextNextShipOnCalculated = Subscription.calculateNextShipOn({
            interval: this.interval,
            nextShipOn: nextShipOnCalculated,
        });
        return this.update({
            active: true,
            cancellationReason: undefined,
            cancelledAt: undefined,
            lastOrderPiecePrice: undefined,
            lastOrderPlacedAt: undefined,
            nextNextShipOn: nextNextShipOnCalculated,
            nextShipOn: nextShipOnCalculated,
            nextShipOnAtCancellation: undefined,
        }, { retryConcurrentModification: true });
    };
    Subscription.prototype.skip = function () {
        var nextShipOnCalculated = Subscription.calculateNextShipOn(this);
        var nextNextShipOnCalculated = Subscription.calculateNextShipOn({
            interval: this.interval,
            nextShipOn: nextShipOnCalculated,
        });
        return this.update({
            nextNextShipOn: nextNextShipOnCalculated,
            nextShipOn: nextShipOnCalculated,
        }, { retryConcurrentModification: true });
    };
    Subscription.prototype.buildCancelFieldChanges = function (cancellationReason, cancellationReasonDetails) {
        return {
            active: false,
            cancellationReason: cancellationReason,
            cancellationReasonDetails: cancellationReasonDetails,
            cancelledAt: new Date().toISOString(),
            nextNextShipOn: undefined,
            nextShipOn: undefined,
            nextShipOnAtCancellation: this.nextShipOn,
        };
    };
    Subscription.prototype.buildNewLineItemFields = function (extraFields) {
        if (extraFields === void 0) { extraFields = {}; }
        var thisFields = (0, pick_1.default)(this, ILineItemBaseFields.names, exports.ILineItemCustomFields.names);
        var draft = __assign(__assign(__assign({}, thisFields), { addedAt: undefined, committedPiecePrice: undefined, lastOrderPiecePrice: undefined, lastEventEmitted: undefined, lastEventEmittedAt: undefined, offerType: OfferType.IURecurring }), extraFields);
        var addedAt = draft.addedAt, quantity = draft.quantity, sku = draft.sku, fields = __rest(draft, ["addedAt", "quantity", "sku"]);
        return {
            addedAt: addedAt,
            quantity: quantity,
            sku: sku,
            custom: {
                type: { typeId: 'type', key: 'autoDeliveryLineItem' },
                fields: fields,
            },
        };
    };
    return Subscription;
}());
exports.Subscription = Subscription;
//# sourceMappingURL=Subscription.js.map